function setTitle(title, favIconHref) {
	document.title = title;
}

function setFavicon(favIconHref) {
	let link =
		document.querySelector('link[rel="shortcut icon"]') ||
		document.querySelector('link[rel="icon"]');

	if (!link) {
		link = document.createElement("link");
		link.id = "favicon";
		link.rel = "shortcut icon";
		document.head.appendChild(link);
	}

	link.href = favIconHref;
}

export function setTitleAndFaviconForAurora(pageName) {
	let title = "";
	if (pageName) {
		title = pageName + " | Aurora Payments";
	} else {
		title = "Aurora Payments";
	}
	setTitle(title);
	setFavicon(`/faviconA.ico`);
}
